import CheckboxGroupContainer from "./CheckboxGroupContainer";

export default CheckboxGroupContainer;
